import http from '../http';

export async function listSellerProfiles(params = {}) {
  const { data } = await http.get('/api/admin/seller-profiles', { params });
  return data.items || [];
}

export async function createSellerProfile(body) {
  const { data } = await http.post('/api/admin/seller-profiles', body);
  return data.item;
}

export async function updateSellerProfile(id, body) {
  const { data } = await http.put(`/api/admin/seller-profiles/${id}`, body);
  return data.item;
}

export async function setDefaultSellerProfile(id) {
  const { data } = await http.post(`/api/admin/seller-profiles/${id}/default`);
  return data.item;
}

export async function deleteSellerProfile(id) {
  const { data } = await http.delete(`/api/admin/seller-profiles/${id}`);
  return data;
}
